<template>
  <div>
    <div v-if="messages.length == 0" class="primary-color">{{ $t('No reply') }}</div>
    <ul style="margin: 0;padding: 0;">
      <li
        style="list-style-type: none"
        v-for="(item, index) in messages"
        :key="'intent_item_' + index"
      >
        <template>
          <move-vertical
            :index="index"
            :max="messages.length"
            @onMove="onMove(index, $event)"
            style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"
          >
            <a
              href="javascript:void(0);"
              v-if="messages && messages.length > 0"
              @click="onDelete(index)"
              style="display: block"
            >
              <v-icon small>delete</v-icon>
            </a>
          </move-vertical>
          <template v-if="item.type == 'text'">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 300px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                    <div
                      class="form-control"
                      :class="{
                        'has-error': errors.has(
                          'answer_' + (indexAlternative - 1) + '_text_' + index
                        )
                      }"
                      style="overflow: auto;"
                    >
                      <autoresize-textarea
                        maxlength="640"
                        :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="item.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>

                      <span
                        class="text-error"
                        v-show="errors.has('answer_' + (indexAlternative - 1) + '_text_' + index)"
                      >
                        {{ errors.first('answer_' + (indexAlternative - 1) + '_text_' + index) }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
            </div>

            <intent-manage-prefill
              @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
            ></intent-manage-prefill>
          </template>
          <template v-if="item.type == 'button'">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 300px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div
                    style="padding: 8px 6px 2px;background-color:#F1F0F0;border-top-left-radius: 10px;border-top-right-radius: 10px;"
                  >
                    <div
                      class="form-control"
                      :class="{
                        'has-error': errors.has(
                          'answer_' + (indexAlternative - 1) + '_text_' + index
                        )
                      }"
                      style="overflow: auto;"
                    >
                      <autoresize-textarea
                        maxlength="640"
                        :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="item.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>

                      <span
                        class="text-error"
                        v-show="errors.has('answer_' + (indexAlternative - 1) + '_text_' + index)"
                      >
                        {{ errors.first('answer_' + (indexAlternative - 1) + '_text_' + index) }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
              <div
                style="float:left;width: 100%;border: 1px solid #eee;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;"
              >
                <ul class="message-group message-group-flush" style="margin-bottom: 0px;">
                  <template v-if="item.buttons && item.buttons.length > 0">
                    <li
                      class="message-group-item"
                      style="position:relative;border-left:none;border-right:none;border-bottom:none; border-radius: 0px;text-align: center;padding: 5px 10px"
                      :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                      v-for="(button, bindex) in item.buttons"
                      :key="bindex"
                    >
                      <div style="position: absolute;right: -45px;top: 0px;">
                        <v-btn
                          fab
                          outline
                          color="primary"
                          small
                          class="extra-small"
                          @click="deleteButton(index, bindex)"
                        >
                          <v-icon small>delete</v-icon>
                        </v-btn>
                      </div>
                      <span style="overflow: auto;position: relative">
                        <add-generic-button
                          v-model="item.buttons[bindex]"
                          :key="'intent_button_' + index + '_' + bindex + '_' + editTimestamp"
                          @onSave="editButton(index, bindex, $event)"
                        >
                          <span style="color: #0084FF;" :title="button.title">
                            {{ button.title | truncate(12) }}
                          </span>
                          <v-icon small>edit</v-icon>
                        </add-generic-button>
                        <div class="clearfix"></div>

                        <div style="margin: 0;font-size: 10px;">
                          <span v-if="button.type == 'web_url'" :title="button.url">
                            {{ button.url | truncate(20) }}
                          </span>
                          <span v-else-if="button.type == 'postback'" :title="button.payload">
                            {{ button.payload | truncate(20) }}
                          </span>
                          <span v-else-if="button.type == 'phone_number'" :title="button.payload">
                            {{ button.payload | truncate(20) }}
                          </span>
                          <span v-else>&nbsp;</span>
                        </div>
                      </span>
                    </li>
                  </template>
                  <li
                    v-if="item.buttons && item.buttons.length < 3"
                    class="message-group-item"
                    style="border-left:none;border-right:none;border-bottom:none;border-radius: 0px;text-align: center;padding: 10px 0px"
                    :style="{ 'border-top': item.buttons.length != 0 ? '1px solid #eee' : 'none' }"
                  >
                    <add-generic-button
                      :key="'intent_button_' + index + '_new_' + saveTimestamp"
                      v-model="newButton"
                      @onSave="addNewButton(index, $event)"
                    >
                      <v-icon small>edit</v-icon>
                      {{ $t('Add button') }}
                    </add-generic-button>
                  </li>
                </ul>
              </div>
              <input
                type="hidden"
                v-validate="''"
                :name="'answer_' + (indexAlternative - 1) + '_buttons_' + index"
                v-model="item.buttons.length"
                data-vv-as="Buttons"
              />
              <div
                class="form-control"
                :class="{
                  'has-error': errors.has('answer_' + (indexAlternative - 1) + '_buttons_' + index)
                }"
              >
                <span
                  class="text-error"
                  v-show="errors.has('answer_' + (indexAlternative - 1) + '_buttons_' + index)"
                >
                  {{ errors.first('answer_' + (indexAlternative - 1) + '_buttons_' + index) }}
                </span>
              </div>
            </div>
            <intent-manage-prefill
              @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
            ></intent-manage-prefill>
          </template>
          <template v-else-if="item.type == 'image'">
            <div
              :ref="'answer_' + (indexAlternative - 1) + '_' + index"
              class="message"
              style="float:left;position:relative;border-radius: 12px;width: 300px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
            >
              <z-upload-file
                ref="answer"
                v-model="item.image_url"
                :height="181"
                data-vv-as="Image"
                :data-vv-name="'answer_' + (indexAlternative - 1) + '_image_' + index"
                v-validate
              ></z-upload-file>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="item.type == 'video'">
            <div :ref="'answer_' + (indexAlternative - 1) + '_' + index" class="message">
              <UploadVideo
                @onChangeFile="handleChangeFile(indexAlternative, index, item.type, $event)"
                style="float: left;"
              >
                <template v-slot="{ handleClickUploadBtn, loading, maxFileSize, fileType }">
                  <template v-if="item.source">
                    <v-layout>
                      <DialogPreviewVideo :videoUrl="item.source">
                        <template v-slot="{ on }">
                          <v-flex
                            v-on="on"
                            class="text-xs-center py-2 px-1"
                            style="width: 181px;border: 1px solid #eee;border-radius: 12px;min-height: 50px;cursor: pointer;"
                          >
                            <v-icon large>play_arrow</v-icon>
                            <div
                              class="primary--text truncate"
                              style="max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                              :alt="handleGetFileNameFromUrl(item.source)"
                            >
                              {{ handleGetFileNameFromUrl(item.source) }}
                            </div>
                            <div class="caption">Click to play video</div>
                          </v-flex>
                        </template>
                      </DialogPreviewVideo>
                      <v-flex>
                        <v-btn
                          icon
                          small
                          outline
                          color="primary"
                          @click="handleClickUploadBtn"
                          :loading="loading"
                        >
                          <v-icon small>upload</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else>
                    <div
                      shrink
                      class="text-xs-center py-2"
                      style="width: 181px;border: 1px solid #eee;border-radius: 12px;min-height: 50px;cursor: pointer;"
                    >
                      <div style="height: 100%" @click="handleClickUploadBtn">
                        <v-icon large>upload</v-icon>
                        <div class="caption">Click to upload video</div>
                        <div class="caption">
                          อัปโหลดไฟล์ไม่เกิน {{ maxFileSize }} mb และนามสกุลไฟล์
                          {{ fileType.join(',') }}
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </UploadVideo>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="item.type == 'audio'">
            <div :ref="'answer_' + (indexAlternative - 1) + '_' + index" class="message">
              <UploadAudio
                @onChangeFile="handleChangeFile(indexAlternative, index, item.type, $event)"
                style="float: left;"
              >
                <template v-slot="{ handleClickUploadBtn, loading, maxFileSize }">
                  <template v-if="item.source">
                    <v-layout>
                      <DialogPreviewAudio :audioUrl="item.source">
                        <template v-slot="{ on }">
                          <v-flex
                            v-on="on"
                            class="text-xs-center py-2 px-1"
                            style="width: 181px;border: 1px solid #eee;border-radius: 12px;min-height: 50px;cursor: pointer;"
                          >
                            <v-icon large>audiotrack</v-icon>
                            <div
                              class="primary--text truncate"
                              style="max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                              :alt="handleGetFileNameFromUrl(item.source)"
                            >
                              {{ handleGetFileNameFromUrl(item.source) }}
                            </div>
                            <div class="caption">
                              {{ handleConvertSecondToMinute(item.duration) }} min
                            </div>
                            <div class="caption">Click to play audio</div>
                          </v-flex>
                        </template>
                      </DialogPreviewAudio>
                      <v-flex>
                        <v-btn
                          icon
                          small
                          outline
                          color="primary"
                          @click="handleClickUploadBtn"
                          :loading="loading"
                        >
                          <v-icon small>upload</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else>
                    <div
                      shrink
                      class="text-xs-center py-2"
                      style="width: 181px;border: 1px solid #eee;border-radius: 12px;min-height: 50px;cursor: pointer;"
                    >
                      <div style="height: 100%" @click="handleClickUploadBtn">
                        <v-icon large>upload</v-icon>
                        <div class="caption">Click to upload audio</div>
                        <div class="caption">
                          อัปโหลดไฟล์ไม่เกิน {{ maxFileSize }} mb และนามสกุลไฟล์ .mp3
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </UploadAudio>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="item.type == 'generic'">
            <intent-manage-generic
              v-model="item.data"
              @deleteMessage="onDelete(index)"
            ></intent-manage-generic>
          </template>

          <div class="clearfix"></div>
          <div class="form-control has-error" style="margin-left: 30px">
            <span
              class="text-error"
              v-show="errors.has('answer_' + (indexAlternative - 1) + '_image_' + index)"
              >{{ errors.first('answer_' + (indexAlternative - 1) + '_image_' + index) }}</span
            >
          </div>
          <div style="margin-bottom: 10px;"></div>
        </template>
      </li>
    </ul>

    <div style="width: 100%;overflow-x: auto;margin-top: 15px;">
      <label for class="caption">{{ $t('Add more item') }}</label>
      <ul class="customize-message-tool">
        <li @click="addIntentItem('text')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Message') }}
        </li>
        <li @click="addIntentItem('button')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-button.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Button') }}
        </li>
        <li @click="addIntentItem('image')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-image.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Image') }}
        </li>
        <li @click="addIntentItem('generic')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Menu list') }}
        </li>
        <li @click="addIntentItem('video')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-video.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Video') }}
        </li>
        <li @click="addIntentItem('audio')" :class="{ inactive: bubbleCount >= addLimit }">
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-audio.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Audio') }}
        </li>
      </ul>
    </div>
    <v-dialog persistent v-model="showVariable" max-width="600" style="overflow: visible;">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="onCancelVariable">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-autocomplete
            v-model="selectedVariable"
            :items="filterVariable"
            outline
            label="Variable"
          >
          </v-autocomplete>

          <div class="text-xs-center">
            <v-btn outline color="grey" @click="onCancelVariable">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="onSaveVariable">{{ $t('Save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import IntentManagePrefill from './IntentManagePrefill'
import IntentManageGeneric from './IntentManageGeneric'
import AddGenericButton from './AddGenericButton'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import MoveVertical from '@/components/elements/MoveVertical'
import ZUploadFile from '@/components/elements/UploadFile'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import UploadAudio from './UploadAudio.vue'
import UploadVideo from './UploadVideo.vue'
import DialogPreviewAudio from './DialogPreviewAudio.vue'
import DialogPreviewVideo from './DialogPreviewVideo.vue'
import moment from 'moment'
export default {
  props: ['value', 'indexAlternative'],
  data() {
    return {
      messages: [],
      addLimit: 10,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      showVariable: false,
      selectedVariable: '',
      prefill: null,
      editTimestamp: moment().format('x'),
      saveTimestamp: moment().format('x'),
      showVideoDialog: false,
      showAudioDialog: false,
      currentVideo: null,
      currentAudio: null,
      currentPosition: {
        alternative: null,
        index: null
      }
    }
  },
  components: {
    specialtext,
    IntentManagePrefill,
    IntentManageGeneric,
    AddGenericButton,
    AutoresizeTextarea,
    MoveVertical,
    ZUploadFile,
    Multiselect,
    UploadAudio,
    UploadVideo,
    DialogPreviewAudio,
    DialogPreviewVideo
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    bubbleCount: function() {
      var vm = this
      if (vm.messages) {
        return vm.messages.length
      } else {
        return 0
      }
    },
    filterVariable() {
      var vm = this
      var variable = []
      if (vm.variable) {
        variable = vm.variable.filter(el => {
          return el.flowid == 0 || (this.selectedFlow && el.flowid == this.selectedFlow.id)
        })
      }
      var result = []
      variable.map(el => {
        result.push({
          text: el.name,
          value: el.name
        })
      })
      return result
    }
  },
  mounted() {
    this.messages = this.value
  },
  methods: {
    handleConvertSecondToMinute(val) {
      if (val) {
        const duration = val
        const minutes = Math.floor(duration / 60)
        const seconds = duration - minutes * 60
        return minutes + ':' + seconds.toFixed(0)
      } else {
        return ''
      }
    },
    handleGetFileNameFromUrl(val) {
      if (val) {
        const url = val
        const filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
        return filename
      } else {
        return ''
      }
    },
    handleChangeFile(indexAlternative, index, type, file) {
      const vm = this
      vm.$set(vm.messages[index], 'source', file.url)
      vm.$set(vm.messages[index], 'sourceline', file.url)
      if (type == 'audio') {
        vm.$set(vm.messages[index], 'duration', file.duration)
      }
    },
    onMove: function(index, direction) {
      var vm = this

      if (direction === 'up') {
        vm.messages.splice(index, 0, vm.messages.splice(index - 1, 1)[0])
      } else if (direction === 'down') {
        vm.messages.splice(index, 0, vm.messages.splice(index + 1, 1)[0])
      }
    },
    onCancelVariable() {
      this.showVariable = false
      this.selectedVariable = ''
    },
    onSaveVariable() {
      var vm = this
      if (vm.messages[vm.prefill.index].type === 'text') {
        vm.$set(
          vm.messages[vm.prefill.index],
          'text',
          [
            vm.messages[vm.prefill.index].text.slice(0, vm.prefill.cursorPosition),
            '{' + vm.selectedVariable + '}',
            vm.messages[vm.prefill.index].text.slice(vm.prefill.cursorPosition)
          ].join('')
        )
      } else if (vm.messages[vm.prefill.index].type == 'button') {
        vm.$set(
          vm.messages[vm.prefill.index],
          'text',
          [
            vm.messages[vm.prefill.index].text.slice(0, vm.prefill.cursorPosition),
            '{' + vm.selectedVariable + '}',
            vm.messages[vm.prefill.index].text.slice(vm.prefill.cursorPosition)
          ].join('')
        )
      }
      this.showVariable = false
      this.selectedVariable = ''
    },
    onChange(value) {},
    addIntentPrefill(alternative, index, payload) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + alternative + '_' + index][0].$el.selectionStart
      if (payload == 'variable') {
        vm.prefill = {
          cursorPosition: cursorPosition,
          alternative: alternative,
          index: index
        }
        vm.showVariable = true
      } else {
        if (vm.messages[index].type === 'text') {
          vm.$set(
            vm.messages[index],
            'text',
            [
              vm.messages[index].text.slice(0, cursorPosition),
              '{' + payload + '}',
              vm.messages[index].text.slice(cursorPosition)
            ].join('')
          )
        } else if (vm.messages[index].type == 'button') {
          vm.$set(
            vm.messages[index],
            'text',
            [
              vm.messages[index].text.slice(0, cursorPosition),
              '{' + payload + '}',
              vm.messages[index].text.slice(cursorPosition)
            ].join('')
          )
        }
      }
    },
    addIntentItem(type) {
      if (this.bubbleCount >= this.addLimit) {
        return false
      }
      if (type == 'text') {
        this.messages.push({
          text: '',
          type: type
        })
      } else if (type == 'button') {
        this.messages.push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image') {
        this.messages.push({
          image_url: '',
          type: type
        })
      } else if (type == 'generic') {
        this.messages.push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'video') {
        this.messages.push({
          type: type,
          source: '',
          sourceline: ''
        })
      } else if (type == 'audio') {
        this.messages.push({
          type: type,
          source: '',
          sourceline: '',
          duration: 0
        })
      }
    },
    addNewButton: function(index, payload) {
      if (this.messages[index].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.messages[index].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
      }
      this.saveTimestamp = moment().format('x')
    },
    editButton: function(index, bindex, payload) {
      if (this.messages[index].buttons[bindex]) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.messages[index].buttons, bindex, payload)
        this.editTimestamp = moment().format('x')
      }
    },
    deleteButton: function(index, bindex) {
      this.messages[index].buttons.splice(bindex, 1)
    },
    onDelete: function(index) {
      this.messages.splice(index, 1)
      this.$emit('input', this.messages)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/IntentManageAnswer.vue